import axios from 'axios';
import { getResponseData } from './api.utils';
export const get = async () => {
    const endpoint = 'FeatureFlags';
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
